import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import ContactHeroSection from "../components/Contact/ContactHeroSection";
import ContactMotivationBanner from "../components/Contact/ContactMotivationBanner";
import ContactFormSection from "../components/Contact/ContactFormSection";
import GymCardsSection from "../components/Contact/GymCardsSection";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contacto NovaXFit | Gimnasio en La Libertad</title>
        <meta
          name="description"
          content="Contacta a NovaXFit, gimnasio en La Libertad, provincia de Santa Elena. Consulta planes, horarios, ubicación, entrenamientos y atención para usuarios."
        />
        <link rel="canonical" href="https://novaxfit.com/contacto" />
      </Helmet>

      <div>
        <ContactHeroSection />
        <GymCardsSection />
        <ContactMotivationBanner />
        <ContactFormSection />
      </div>
    </>
  );
}

export default Contact;